import {
  SavingIndicator,
  SavingIndicatorStatus,
} from '../../../../components/indicator/index';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { IAppStore } from 'stores/AllStores';

// Styles
const s = require('./GroupItem.css');

// Props
interface IGroupItemProps {
  store?: IAppStore;
}

// Component
@inject('store')
@observer
export class GroupItem extends React.Component<IGroupItemProps, {}> {
  constructor(props: IGroupItemProps) {
    super(props);

    this.props.store.leadGroup.addLeadToGroup(
      this.props.store.leadGroup.openedGroup.id
    );
  }

  public render() {
    const { openedGroup } = this.props.store.leadGroup;

    return (
      <SavingIndicator
        align="center"
        className={s.saving}
        labels={{
          saving: `Assigning to group${
            openedGroup.name ? ' "' + openedGroup.name + '"' : '...'
          }`,
        }}
        status={SavingIndicatorStatus.Saving}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.tsx